import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import {
  setDateSlotVisible,
  addTimeSlot,
  removeTimeSlot,
  updateSettings,
  saveRestaurantSlots,
  fetchAppointmentConfig,
} from "dan-redux/modules/dateSlotSystem";
import ModalInformation from "../../../Pages/Ortak/ModalInformation";

const styles = (theme) => ({
  dialogPaper: {
    backgroundColor: "#424242",
    color: "#fff",
  },
  dayPaper: {
    padding: theme.spacing(2),
    backgroundColor: "#3e3e3e",
    color: "#fff",
    height: "100%",
    position: "relative",
  },
  slotForm: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#4e4e4e",
  },
  timeSlot: {
    backgroundColor: "#5e5e5e",
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  settingsSection: {
    backgroundColor: "#3e3e3e",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  actionButton: {
    margin: theme.spacing(1),
  },
  saveButton: {
    backgroundColor: "#00a0b2",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#008999",
    },
  },
  exitButton: {
    backgroundColor: "#F44336",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#d32f2f",
    },
  },
});

class DateSlotSystem extends React.Component {
  state = {
    selectedDay: null,
    startTime: "",
    endTime: "",
  };

  componentDidMount() {
    if (this.props.open && this.props.brandId) {
      this.props.fetchAppointmentConfig();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.open && this.props.open) ||
      (prevProps.brandId !== this.props.brandId && this.props.open)
    ) {
      this.props.fetchAppointmentConfig();
      this.setState({ selectedDay: null });
    }
  }

  handleDayClick = (day) => {
    this.setState({ selectedDay: this.state.selectedDay === day ? null : day });
  };

  handleAddSlot = () => {
    const { selectedDay, startTime, endTime } = this.state;
    if (selectedDay && startTime && endTime) {
      this.props.addTimeSlot(selectedDay, startTime, endTime);
      this.setState({ startTime: "", endTime: "" });
    }
  };

  handleClose = () => {
    this.props.setDateSlotVisible(false);
    this.setState({ selectedDay: null });
  };

  handleSave = () => {
    const { brandId } = this.props;
    if (brandId) {
      this.props.saveRestaurantSlots(brandId);
    }
  };

  handleSettingsChange = (name) => (event) => {
    const value =
      name === "useAppointmentSystem"
        ? event.target.checked
        : event.target.value;
    this.props.updateSettings({ [name]: value });
  };

  modalClose = () => {
    this.props.setDateSlotVisible(false);
  };

  renderSettings = () => {
    const { classes, currentRestaurantData } = this.props;
    const settings = currentRestaurantData.get("settings");

    return (
      <Paper className={classes.settingsSection}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={settings.get("useAppointmentSystem")}
                  onChange={this.handleSettingsChange("useAppointmentSystem")}
                  color="primary"
                />
              }
              label="Randevu sistemini kullan"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Otomatik atamanın kaç dakika öncesinden başlayacağı"
              type="number"
              value={settings.get("preStartMinutes")}
              onChange={this.handleSettingsChange("preStartMinutes")}
              disabled={!settings.get("useAppointmentSystem")}
              InputProps={{ inputProps: { min: 0 } }}
              fullWidth
            />
          </Grid>
        </Grid>
      </Paper>
    );
  };

  renderDaySlots = (day) => {
    const { classes, currentRestaurantData } = this.props;
    const daySlots = currentRestaurantData.getIn(["slots", day.toString()], []);

    return daySlots.map((slot, index) => (
      <div key={index} className={classes.timeSlot}>
        <span>
          {slot.get("startTime")} - {slot.get("endTime")}
        </span>
        <IconButton
          size="small"
          onClick={() => this.props.removeTimeSlot(day, index)}
        >
          <Icon>delete</Icon>
        </IconButton>
      </div>
    ));
  };

  renderDays = () => {
    const { classes } = this.props;
    const { selectedDay } = this.state;
    const days = Array.from({ length: 31 }, (_, i) => i + 1);

    return (
      <Grid container spacing={2}>
        {days.map((day) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={day}>
            <Paper
              className={classes.dayPaper}
              style={{
                border: selectedDay === day ? "2px solid #00a0b2" : "none",
              }}
            >
              <Typography variant="h6" gutterBottom>
                {day}. Gün
                <IconButton
                  size="small"
                  style={{ float: "right" }}
                  onClick={() => this.handleDayClick(day)}
                >
                  <Icon>{selectedDay === day ? "remove" : "add"}</Icon>
                </IconButton>
              </Typography>
              {this.renderDaySlots(day)}
              {selectedDay === day && (
                <div className={classes.slotForm}>
                  <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <TextField
                        label="Başlangıç"
                        type="time"
                        value={this.state.startTime}
                        onChange={(e) =>
                          this.setState({ startTime: e.target.value })
                        }
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        label="Bitiş"
                        type="time"
                        value={this.state.endTime}
                        onChange={(e) =>
                          this.setState({ endTime: e.target.value })
                        }
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <IconButton
                        color="primary"
                        onClick={this.handleAddSlot}
                        style={{ marginTop: 16 }}
                      >
                        <Icon>add_circle</Icon>
                      </IconButton>
                    </Grid>
                  </Grid>
                </div>
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>
    );
  };

  render() {
    const { classes, open, businessName, error } = this.props;

    return (
      <>
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="date-slot-dialog-title"
          fullWidth
          maxWidth="xl"
          PaperProps={{ classes: { root: classes.dialogPaper } }}
        >
          <DialogTitle id="date-slot-dialog-title">
            {businessName
              ? `${businessName} - Randevu Sistemi Slot Yönetimi`
              : "Randevu Tanımları"}
          </DialogTitle>
          <DialogContent>
            {this.renderSettings()}
            {this.renderDays()}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleSave}
              variant="contained"
              className={`${classes.actionButton} ${classes.saveButton}`}
            >
              Kaydet
            </Button>
            <Button
              onClick={this.handleClose}
              variant="contained"
              className={`${classes.actionButton} ${classes.exitButton}`}
            >
              Çıkış
            </Button>
          </DialogActions>
        </Dialog>
        <ModalInformation
          open={!!error}
          title="Bilgi"
          text={error}
          event={this.modalClose}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const dateSlotSystem = state.get("dateSlotSystemReducer");
  const dateSlotData = dateSlotSystem?.get("dateSlotData");

  return {
    open: dateSlotSystem?.get("dateSlotVisible") || false,
    businessName: dateSlotData?.get("BusinessName") || "",
    brandId: dateSlotData?.get("BrandId") || "",
    error: dateSlotSystem?.get("error"),
    currentRestaurantData:
      dateSlotSystem?.get("currentRestaurantData") ||
      fromJS({
        slots: {},
        settings: {
          useAppointmentSystem: false,
          preStartMinutes: 10,
        },
      }),
  };
};

const mapDispatchToProps = {
  setDateSlotVisible,
  addTimeSlot,
  removeTimeSlot,
  updateSettings,
  saveRestaurantSlots,
  fetchAppointmentConfig,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DateSlotSystem));
